import Vue from 'vue';
import qs from 'qs';

export async function getVipInfo(params) {
  const result = await Vue.prototype.httpGet('user/limits');
  return result.data;
}

export function getVipProducts(purpose) {
  return Vue.prototype.httpGet(`products?purpose=${purpose}`);
}

export function createOrder(params) {
  return Vue.prototype.httpPost('orders/buy', params);
}

export function checkOrder(id) {
return Vue.prototype.httpGet(`wechat/order/${id}`);
}

export function getOrders(params) {
  if ((params.purpose || []).length < 1) {
    params.purpose = ['PC'];
  }
  const queryStr = qs.stringify({ ...params, statuses: ['SUCCESS'] }, { arrayFormat: 'repeat' })
  return Vue.prototype.httpGet(`v1/api/orders?${queryStr}`);
}

export function getInvoiceInfo(orderId) {
  return Vue.prototype.httpGet(`v1/api/invoices/order/${orderId}`);
}

export function uploadInvoiceInfo(params) {
  return Vue.prototype.httpPost(`v1/api/invoices`, params);
}

export function getForecastVip() {
  return new Promise(resolve => {
    Vue.prototype.httpGet('user/VIP').then((data)=>{
      if(data && data.statusCode == 1){
        const item = data.data.find(o => {
          return o.productName === '智能量刑预测';
        });
        resolve(item);
      } else {
        resolve(null);
      }
    })
  });
}

export function getCouponList() {
  return Vue.prototype.httpGet('v1/api/user_coupons/current');
}



// WEBPACK FOOTER //
// ./src/service/vip.js